import { useSessionBootstrap } from '@/queries/auth/useSessionBootstrap';

/** Mounts session bootstrap logic (see hook). */
export function SessionBootstrap() {
  useSessionBootstrap();
  return null;
}
